export default "Base title popover template";